export default __webpack_public_path__ + "img/83a31df5b5a8fe72d2b428d71933b30a.jpg";